export interface ClientFilter {
  tableFilter: string;
  state: string;
  filter: string;
  idTo: string;
  idFrom: string;
  validFrom: string;
  validTo: string;
  ids: string[] | null;
  myClients: boolean;
  responsibleUser: string;
}

export type ClientFilterKey = keyof Omit<ClientFilter, 'myClients' | 'tableFilter'>;

export const defaultFilter: Readonly<ClientFilter> = {
  tableFilter: "",
  filter: "",
  state: "",
  idFrom: "",
  idTo: "",
  validFrom: "",
  validTo: "",
  ids: null,
  myClients: false,
  responsibleUser: "",
};

export function isEmptyFilter(filter: ClientFilter): boolean {
  const fieldsToCheck: ClientFilterKey[] = ['filter', 'state', 'idFrom', 'idTo', 'validFrom', 'validTo', 'responsibleUser'];
  
  return fieldsToCheck.every(key => filter[key] === defaultFilter[key]) &&
    (!filter.ids || filter.ids.length === 0);
}

export function createFilter(partial: Partial<ClientFilter> = {}): ClientFilter {
  return {
    ...defaultFilter,
    ...partial
  };
}

// Export the interface as default for backward compatibility
export default ClientFilter;
